/** @format */

import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';

import { DOCUMENT } from '@angular/common';
import { Environment } from '@shared/data-access/interfaces';

/** @dynamic */
@Injectable({
  providedIn: 'root',
})
export class FooterService {
  private readonly environment = inject(Environment);
  private readonly document = inject(DOCUMENT);
  private readonly rendererFactory = inject(RendererFactory2);
  private readonly renderer: Renderer2 = this.rendererFactory.createRenderer(null, null);

  showFooter(): void {
    const footerId = this.environment.api?.reactMarginals?.footerHTMLId;
    if (!footerId) {
      return;
    }

    const footerElement = this.document.getElementById(footerId);
    if (footerElement) {
      this.renderer.removeClass(footerElement, 'hideReactFooter');
    }
  }
}
